<template>
    <div ref="pc_root" class="pc_root">
        <div v-for="(item, index) in newArr" :key="index">
            <div class="main">
                <!-- Bg -->
                <!-- <img src="../../static/imgs/mainBg.png" class="mainBg" /> -->
                <!-- logo  -->
                <img :src="`../../static/imgs/${language}/logo.png`" class="logo" />
                <!-- 切换语言 -->
                <div class="selectWrap">
                    {{ item[2] }}：
                    <span :style="{ opacity: isBooked ? 0 : 1 }" @click="isBooked = !isBooked"> {{ getLabel }}
                        <img v-show="isBooked" src="../../static/imgs/top.png" />
                        <img v-show="!isBooked" src="../../static/imgs/bottom.png" />
                    </span>
    
                    <div v-show="isBooked" class="selectList" name="slide">
                        <span class="span" @click="isBooked = !isBooked"> {{ getLabel }}
                            <img v-show="isBooked" src="../../static/imgs/top.png" />
                            <img v-show="!isBooked" src="../../static/imgs/bottom.png" />
                        </span>
                        <div class="line"></div>
                        <div class="flexdiv">
                            <div v-for="item in options" :key="item.value" :class="{ hover : item.value == language }" @click="handleClick(item.value)">{{ item.label }}</div>
                        </div>
                    </div>
                </div>
                <!-- 主要内容 -->
                <div class="information">
                    <img :src="`../../static/imgs/${language}/modalBg.png`" class="modalBg" />
    
                    <div>
                        <div class="OperationArea">
                            <p>*{{ item[4] }}：</p>
                            <input v-model="userId" type="text" :placeholder="item[4]" >
                            <p>*{{ item[5] }}：</p>
                            <input v-model="redemption" type="text" :placeholder="item[5]">
                            <p>*{{ item[6] }}：</p>
                            <input type="text" v-model="verification" :placeholder="item[6]">
                            <div class="code">
                                <img :src="verificationCode" alt="" @click="refresh" />
                            </div>
                            <div class="btn_wrap">
                                <img  @click="isModal = 3" v-show="isDisable" :src="`../../static/imgs/${language}/btn.png`" />
                                <img class="isdis" v-show="!isDisable" :src="`../../static/imgs/${language}/dis.png`" />
                            </div>
                        </div>
        
                        <div class="foot_info">
                            <span @click="isModal = 1">{{ item[13] }}</span>
                            <span @click="isModal = 2">{{ item[8] }}</span>
                        </div>
                        <div class="foot_info">
                            <a :href="RE.iosUrl" target="_target"> <img :src="`../../static/imgs/${language}/store_a.png`" /></a>
                            <a :href="RE.AndUrl" target="_target"> <img :src="`../../static/imgs/${language}/store_g.png`" /></a>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- 弹框 -->
            <div class="modalbody" v-show="isModal > 0">
                <div :class="{ modal: true, Interaction: isModal > 2 }">
                    <img @click="isModal = 0" src="../../static/imgs/close.png" class="close" />
    
                    <div class="textWrap" v-show="isModal == 1">
                        <h2>{{ item[13] }}</h2>
                        <p>{{ item[17] }}</p>
                        <img :src="`../../static/imgs/${language}/1.png`" />
                        <p>{{ item[18] }}</p>
                        <img :src="`../../static/imgs/${language}/2.png`" />
                    </div>
                    <div class="textWrap" v-show="isModal == 2">
                        <h2 :class="{ enH2: language == 'en' }">-{{ item[9] }}-</h2>
                        <p>{{ item[10] }}</p>
                        <p>{{ item[11] }}</p>
                        <p>{{ item[12] }}</p>
                        <p><a :href="`mailto:${RE.email}`" target="_target" style="color: #00c6ff; text-decoration: underline;">{{ RE.email }}</a></p>
                    </div>
                    <div class="textWrap" v-show="isModal == 3">
                        <div>
                            <h2>ID:{{ userId }}</h2>
                            <p style="text-align: center">{{ item[33] }}</p>
                        </div>
                        <div class="btnWrap">
                            <span @click="isModal = 0">{{ item[20] }}</span>
                            <span @click="handleYes">{{ item[19] }}</span>
                        </div>
                    </div>
                    <div class="textWrap" v-show="isModal == 4">
                        <p style="text-align: center">{{ message }}</p>
                        <div class="btnWrap">
                            <span @click="handleOk" class="spanOk" > OK </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Footer></Footer> -->
    </div>
</template>

<script>
import Footer from '@/components/footer'
import pcLogic from './index.js'

export default {
    components: {
        Footer
    },
    props: ['language'],
    mixins: [pcLogic]
}
</script>

<style scoped lang="less">
    @import "./pc.less";
</style>


// WEBPACK FOOTER //
// src/components/pc.vue